/**
 * i18n Configuration
 *
 * Centralized configuration for internationalization settings.
 * Modify this file to add/remove supported languages or change defaults.
 */

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const NAMESPACES = [
  'common',
  'auth',
  'navigation',
  'backups',
  'dashboard',
  'agents',
  'admin',
  'restores',
  'settings',
  'billing',
  'compliance',
  'storage',
  'errors',
  'validation',
  'notifications',
  'auditLogs',
  'onboarding',
  'landing',
  'legal',
] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NS: Namespace = 'common';

// Language detection options
export const DETECTION_OPTIONS = {
  // Order of language detection
  order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'] as string[],

  // Keys to look for in querystring, cookie, and localStorage
  lookupQuerystring: 'lang',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',

  // Cache user language preference
  caches: ['localStorage', 'cookie'] as Array<'localStorage' | 'cookie'>,
  cookieMinutes: 10080, // 7 days
};

// Interpolation settings
export const INTERPOLATION_CONFIG = {
  escapeValue: false, // React already escapes values
  formatSeparator: ',',
};

// Backend loading configuration
export const BACKEND_CONFIG = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  addPath: '/locales/add/{{lng}}/{{ns}}',
  allowMultiLoading: true,
  crossDomain: false,
  withCredentials: false,
  overrideMimeType: false,
};

// Debug mode (disable to suppress console messages)
export const DEBUG_MODE = false;

// React i18next specific options
export const REACT_OPTIONS = {
  useSuspense: false,
};
